<div class="row no-gutters mb-1"
     *ngIf="label">
    <span class="validity-period-label"
          [ngClass]="{ 'required': invalid }">
        {{ label | translate }}
    </span>
</div>

<div class="row no-gutters">
    <div *ngFor="let period of periods">
        <div id="{{idPrefix}}btn.{{period.value}}"
             class="col period {{ size }}"
             [ngClass]="{ 'active': selectedPeriod === period.value, 'required': invalid, 'disabled': disabled }"
             (click)="selectPeriod(period)">
            {{ period.label }}
        </div>
    </div>
</div>
